import React from "react";
import { Grid } from "@mui/material";
import EditTable from "../../../components/Components/MaterialOutwardTable";
import { useQuery } from "react-query";
import { getMaterialOutwardList } from "../mutations/TransactionsMutation";

function MaterialInward() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: materialInwardData } = useQuery(
    "material-outward-transactions",
    () => getMaterialOutwardList(formattedDate),
    { refetchOnMount: true }
  );

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Material Outward Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditTable tableData={materialInwardData ?? []} />
      </Grid>
    </Grid>
  );
}

export default MaterialInward;
